import React, { Fragment } from "react"
import { Helmet } from "react-helmet"
import { Link } from "react-router-dom"




//componets
import ThemeMenuThree from "../../../components/header/ThemeMenuThree"
import PageTitle from "../../../components/page-title/PageTitle"
import BlogStyleThree from "../../../components/blog/BlogStyleThree"
import NewsletterTwo from "../../../components/call-to-action/NewsletterTwo"
import FooterThree from "../../../components/footer/FooterThree"




const BlogGrid = () => {

    return (
        <Fragment>
            <div className="main-page-wrapper">
                {/* Helmet start */}
                <Helmet>
                    <title>Blog Mosaico – Artículos de Tecnología</title>
                    <meta name="description" content="Explora nuestros artículos sobre tecnología, ciberseguridad y desarrollo web en formato mosaico. Blog de CuySoft Ecuador." />
                    <link rel="canonical" href="https://www.cuysoft.com/blog-masonry" />
                </Helmet>
                {/* Helmet end */}

                {/* ThemeMenuThree */}
                <ThemeMenuThree />
                {/* ThemeMenuThree */}

                {/* PageTitle */}
                <PageTitle title="Blog Mosaico" />
                {/* PageTitle */}

                {/*blog-grid-area start*/}
                <section className="blog-masonry-area pt-150 pb-105 pt-lg-60 pb-lg-15">
                    <div className="container">
                        {/* BlogStyleThree start */}
                        <BlogStyleThree />
                        {/* BlogStyleThree end */}
                        <div className="row">
                            <div className="col-lg-12 d-flex align-items-center justify-content-center mt-20 mb-45">
                                <Link className="theme_btn" to="/blog-details-v1">Cargar Más</Link>
                            </div>
                        </div>
                    </div>
                </section>
                {/*blog-grid-area end*/}


                {/*cuysoft-newsletter start*/}
                <NewsletterTwo />
                {/*cuysoft-newsletter end*/}

                {/* FooterThree start */}
                <FooterThree />
                {/* FooterThree end */}

            </div>

        </Fragment>
    )
}

export default BlogGrid